'use client';

import { Dispatch, SetStateAction, use } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AnalyticsEventNames } from '@/analytics/Event.types';
import { analytics } from '@/analytics/segment';
import { StepContext } from '../StepContext';
import { STEPS } from '../types';

export default function ConfirmModal({
  show,
  setShowConfirmModal,
  onCloseModals,
}: {
  show: boolean;
  setShowConfirmModal: Dispatch<SetStateAction<boolean>>;
  onCloseModals: () => void;
}): JSX.Element | null {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('desktop'));
  const stepContext = use(StepContext);

  const handleExit = () => {
    analytics.track(AnalyticsEventNames.BUYER_PREFERENCES_MODAL_DISMISSED, {
      stepIndex: stepContext.stepIndex,
      stepName: STEPS[stepContext.stepIndex].filterAttribute,
      unsavedChanges: stepContext.isDirty,
    });
    onCloseModals();
  };

  return (
    <Dialog
      open={show}
      fullScreen={!isDesktop}
      sx={{
        '& .MuiDialog-paper': {
          p: 0,
          borderRadius: { desktop: 3, mobile: 0 },
        },
      }}
    >
      <Box maxWidth={800} minWidth={{ desktop: 800 }} p={4}>
        <Stack
          direction={{ mobile: 'column-reverse', desktop: 'row' }}
          justifyContent={{ desktop: 'space-between' }}
          width="100%"
        >
          <Typography variant="h2">Confirm exit</Typography>
        </Stack>
        <DialogContent>
          <Typography>
            Are you sure you want to exit without finishing answering questions about your
            preferences?
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            marginTop: 4,
            justifyContent: isDesktop ? 'flex-end' : 'center',
          }}
        >
          <Stack
            gap={{ mobile: 2, desktop: 1 }}
            flexGrow={{ mobile: 1, desktop: 0 }}
            direction={{ mobile: 'column', desktop: 'row' }}
          >
            <Button
              variant="outlined"
              fullWidth={!isDesktop}
              onClick={() => setShowConfirmModal(false)}
            >
              Back
            </Button>
            <Button fullWidth={!isDesktop} onClick={handleExit}>
              Exit
            </Button>
          </Stack>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
